import { Badge } from "@/components/ui/badge";
import type { Database } from "@/integrations/supabase/types";

type OrderStatus = Database["public"]["Enums"]["order_status"];

const statusConfig: Record<
  OrderStatus,
  { label: string; variant: "default" | "secondary" | "destructive" | "outline" }
> = {
  pending: { label: "Pendente", variant: "secondary" },
  preparing: { label: "Em Preparo", variant: "default" },
  ready: { label: "Pronto", variant: "outline" },
  out_for_delivery: { label: "Em Rota", variant: "default" },
  delivered: { label: "Entregue", variant: "default" },
  cancelled: { label: "Cancelado", variant: "destructive" },
  paid: { label: "Pago", variant: "default" },
};

interface OrderStatusBadgeProps {
  status: OrderStatus;
}

export function OrderStatusBadge({ status }: OrderStatusBadgeProps) {
  const config = statusConfig[status];

  return (
    <Badge 
      variant={config.variant}
      className={
        status === "preparing" 
          ? "bg-amber-500 hover:bg-amber-600" 
          : status === "ready" 
          ? "bg-emerald-500 text-white hover:bg-emerald-600" 
          : status === "out_for_delivery"
          ? "bg-blue-500 text-white hover:bg-blue-600"
          : status === "delivered"
          ? "bg-primary hover:bg-primary/90"
          : ""
      }
    >
      {config.label}
    </Badge>
  );
}
